import React from "react";

import { ActivityFilterType } from "../../../../../services/holdings";
import { CheckboxFilter } from "./CheckboxFilter";
import {
  ACTIVITY_TYPE_FILTER_OPTIONS,
  ACTIVITY_TYPE_FILTER_ORDER,
} from "./constants";
import { ActivityTypeFilterProps, CheckboxFilterChoice } from "./types";

const TYPE_OPTIONS: CheckboxFilterChoice<ActivityFilterType>[] =
  ACTIVITY_TYPE_FILTER_ORDER.map((type) => ({
    value: type,
    label: ACTIVITY_TYPE_FILTER_OPTIONS[type],
  }));

const triggerLabelOf = (selected: ActivityFilterType[]) => {
  if (selected.length === 0) {
    return "All types";
  }
  return selected.length === 1 ? "1 type" : `${selected.length} types`;
};

const ActivityTypeFilterComponent: React.FC<ActivityTypeFilterProps> = ({
  selected,
  onChange,
  isCompact = false,
}) => {
  return (
    <CheckboxFilter
      options={TYPE_OPTIONS}
      selected={selected}
      onChange={onChange}
      groupLabel="Filter by activity type"
      triggerLabelOf={triggerLabelOf}
      isCompact={isCompact}
    />
  );
};

export const ActivityTypeFilter = React.memo(ActivityTypeFilterComponent);
